// Plan targeting for feature flags. The published JSON carries only these
// numeric ids under a generic `audiences` field — the name↔id mapping must
// exist ONLY here (mirrored as a bare id set in dotell-backend validation).
export type TPlanKey = "trial" | "starter" | "pro" | "team";

export const PLAN_AUDIENCE_IDS: Record<TPlanKey, number> = {
  trial: 1,
  starter: 2,
  pro: 3,
  team: 4,
};

export const PLAN_KEYS: TPlanKey[] = ["trial", "starter", "pro", "team"];

export const planKeyFromId = (id: number): TPlanKey | null =>
  PLAN_KEYS.find((key) => PLAN_AUDIENCE_IDS[key] === id) ?? null;
